
import Vue from "vue";
import { Product, SizeTable } from "@/models/base";
import { ProductService } from "@/services";
import { SizeTableService } from "@/services/size-table-service";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return {
			sizeTableId: null as number | null,
			sizeTables: [] as SizeTable[],
			isRunning: false
		};
	},
	props: {
		selectedItems: {
			type: Array as ()=>Product[],
			required: true
		}
	},
	computed: {
		sizeTableItems():ISelectItem<number | null>[] {
			let items:ISelectItem<number | null>[] = [
				{text: this.$ct("no-size-table").toString(), value: null}
			];
			for (let table of this.sizeTables) {
				if (table.Active) {
					items.push({text: table.Name, value: table.ID});
				}
			}
			return items;
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async confirm(){
			if (this.isRunning) return;
			this.isRunning = true;
			try{
				let productIds = this.selectedItems.map(p=>p.ID);
				let message = this.$ctc("are-you-sure-you-want-to-set-the-size-table-of-count-products", productIds.length, {count: productIds.length}).toString();
				let confirm = await this.$confirmBuilder().setMessage(message).setWarningTitle().show();
				if (!confirm) return;
				await ProductService.setSizeTable(this.sizeTableId, productIds);
				this.$wf.notify(this.$ct("common.success"), "success", 3000, "check");
				this.$emit("refresh");
				this.close();
			}catch(err){

			}finally{
				this.isRunning = false;
			}
		}
	},
	async mounted(){
		this.sizeTables = await SizeTableService.getAll();
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
